var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_wiki"},[_c('div',{staticClass:"c",domProps:{"innerHTML":_vm._s(_vm.htmlData)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }